import {
  EQUIPMENT,
  EQUIPMENT_MESSAGE,
  EXERCISE_TYPE,
  EXERCISE_TYPE_MESSAGE,
  getEquipmentFiltersExercisesSelect,
  getFoundExercisesSelector,
  getMusclesFiltersExercisesSelect,
  getPageExerciseUiSelect,
  getQueryExercisesSelect,
  getTypesFiltersExercisesSelector,
  loadExercisesAction,
  MUSCLE,
  MUSCLE_MESSAGE,
  updatePageExerciseUiAction
} from '@gymaholic/packages'
import { LoadingIcon } from 'components/Icon/icons/loading'
import Page from 'components/Page'
import Text from 'components/Text'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { ROUTE_PATH } from 'modules/routes/constants/index.cjs'
import interpolateRouteUtil from 'modules/routes/utils/interpolate'
import syncReduxToUrlAction from 'modules/training/modules/training-exercises/actions/sync-redux-to-url'
import {
  getCreatedExercisesSelector,
  isExercisesLoadedSelector,
  isExercisesLoadingSelector,
  isQueryExercisesLoadingSelector
} from 'modules/training/modules/training-exercises/selectors'
import React from 'react'
import InfiniteScroll from 'react-infinite-scroll-component'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useDispatch from 'modules/component/utils/hooks/useDispatch.js'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import pushRouterAction from 'modules/router/actions/push'
import getLocationRouterSelect from 'modules/router/selectors/get-location'
import ExerciseRow from 'modules/training/modules/training-exercises/components/Exercises/components/ExerciseRow/index.js'
import { lastArrayUtil } from 'packages/src'
import isReplacingExerciseRouterSelect from 'modules/router/selectors/is-replacing-exercise/index.js'
import AddExercisesHeader from 'modules/training/modules/training-exercises/components/Exercises/components/Header/index.js'

const messages = defineMessages({
  exercises: {
    id: 'Exercises.exercises',
    defaultMessage: 'Exercises'
  },
  replaceExercise: {
    id: 'Exercises.replaceExercise',
    defaultMessage: 'Replace Exercise'
  },
  noExercisesFound: {
    id: 'Exercises.noExercisesFound',
    defaultMessage: 'No exercises found'
  },
  addExercise: {
    id: 'Exercises.addExercise',
    defaultMessage: 'Add Exercise'
  },
  searchExercise: {
    id: 'Exercises.searchExercise',
    defaultMessage: 'Search Exercises'
  },
  filterMuscle: {
    id: 'Exercises.filterMuscle',
    defaultMessage: 'Filter muscle'
  },
  filterEquipment: {
    id: 'Exercises.filterEquipment',
    defaultMessage: 'Filter equipment'
  },
  muscles: {
    id: 'Exercises.muscles',
    defaultMessage: 'Muscles'
  },
  equipment: {
    id: 'Exercises.equipment',
    defaultMessage: 'Equipment'
  },
  types: {
    id: 'Exercises.types',
    defaultMessage: 'Types'
  }
})

export default function AddExercise (props) {
  let muscleUrlParam
  if (props.match.params.muscle !== undefined) {
    muscleUrlParam = MUSCLE[props.match.params.muscle.replace(/ /g, '_')
      .toUpperCase()] || null
  }
  let equipmentUrlParam
  if (props.match.params.equipment !== undefined) {
    equipmentUrlParam = EQUIPMENT[props.match.params.equipment.replace(
      / /g,
      '_'
    ).toUpperCase()] || null
  }
  let typeUrlParam
  if (props.match.params.type !== undefined) {
    typeUrlParam = EXERCISE_TYPE[props.match.params.type.replace(/ /g, '_')
      .toUpperCase()] || null
  }
  const intl = useIntl()
  const dispatch = useDispatch()
  let params
  if (
    muscleUrlParam !== undefined ||
    equipmentUrlParam !== undefined ||
    typeUrlParam !== undefined
  ) {
    params = {
      equipmentFilters: equipmentUrlParam !== undefined
        ? [equipmentUrlParam]
        : [],
      muscleFilters: muscleUrlParam !== undefined ? [muscleUrlParam] : [],
      typesFilters: typeUrlParam !== undefined ? [typeUrlParam] : []
    }
  }
  let exercises = useSelector(getFoundExercisesSelector(params))

  const currentPage = useSelector(getPageExerciseUiSelect)
  const createdExercises = useSelector(getCreatedExercisesSelector())
  const isLoading = useSelector(isExercisesLoadingSelector())
  const isLoaded = useSelector(isExercisesLoadedSelector())
  const [initialLoad, setInitialLoad] = React.useState(true)
  const isQueryLoading = useSelector(isQueryExercisesLoadingSelector())
  const query = useSelector(getQueryExercisesSelect)
  const musclesFilters = useSelector(getMusclesFiltersExercisesSelect)
  const equipmentFilters = useSelector(getEquipmentFiltersExercisesSelect)
  const typesFilters = useSelector(getTypesFiltersExercisesSelector)
  const searchInputRef = React.createRef()
  const location = useSelector(getLocationRouterSelect)
  const locationState = location?.state
  const isReplacing = useSelector(isReplacingExerciseRouterSelect)

  if (createdExercises &&
    createdExercises.data &&
    createdExercises.data.length >
    0) {
    createdExercises.data.map((exerciseId) => {
      const index = exercises.indexOf(exerciseId)
      exercises.splice(index, 1)
      exercises = [
        exerciseId,
        ...exercises
      ]
      return null
    })
  }

  React.useEffect(() => {
    if (initialLoad && isLoaded) {
      setInitialLoad(false)
    }
  }, [isLoaded])

  React.useEffect(() => {
    if (initialLoad) {
      return
    }

    const pathname = props.isReadOnly
      ? ROUTE_PATH.EXERCISES
      : ROUTE_PATH.ADD_EXERCISES_LIST

    if (!props.isReadOnly) {
      return
    }

    if (isReplacing) {
      return
    }

    dispatch(syncReduxToUrlAction(pathname))
  }, [query])

  React.useEffect(() => {
    if (query && query.length > 0 && searchInputRef && searchInputRef.current) {
      searchInputRef.current.focus()
    }
  }, [query])

  if (muscleUrlParam === null || equipmentUrlParam === null || typeUrlParam === null) {
    pushRouterAction({
      pathname: ROUTE_PATH.EXERCISES
    })
  }

  const fetchMoreData = () => {
    const lastExerciseId = lastArrayUtil(exercises)
    dispatch(updatePageExerciseUiAction(currentPage + 1))

    if (muscleUrlParam) {
      dispatch(loadExercisesAction({
        shouldExcludeIds: true,
        query: {
          lastId: lastExerciseId,
          muscles: muscleUrlParam,
          limit: 10
        }
      }))
    } else if (equipmentUrlParam) {
      dispatch(loadExercisesAction({
        shouldExcludeIds: true,
        query: {
          lastId: lastExerciseId,
          equipment: equipmentUrlParam,
          limit: 10
        }
      }))
    } else if (typeUrlParam) {
      dispatch(loadExercisesAction({
        shouldExcludeIds: true,
        query: {
          lastId: lastExerciseId,
          type: typeUrlParam,
          limit: 10
        }
      }))
    } else {
      dispatch(loadExercisesAction({
        shouldUseFilters: true,
        query: {
          lastId: lastExerciseId,
          limit: 10
        },
        shouldExcludeIds: true
      }))
    }
  }

  const handleClickExercise = (id, slug) => {
    if (props.isReadOnly) {
      dispatch(
        pushRouterAction({
          pathname: interpolateRouteUtil(
            ROUTE_PATH.VIEW_EXERCISE_SLUG,
            {
              id,
              slug
            }
          )
        })
      )
      return
    }

    dispatch(
      pushRouterAction({
        pathname: interpolateRouteUtil(
          ROUTE_PATH.ADD_EXERCISE,
          {
            id
          }
        )
      }, {
        originMatch: locationState?.originMatch,
        workoutSectionId: locationState?.workoutSectionId,
        replacingWorkoutExerciseId: locationState?.replacingWorkoutExerciseId,
        searchParams: locationState?.searchParams
          ? locationState?.searchParams
          : null
      })
    )
  }

  let exercisesMsg = formatMessageIntlUtil(intl, messages.exercises)

  if (muscleUrlParam ||
    (
      musclesFilters.length ===
      1 &&
      equipmentFilters.length ===
      0 &&
      typesFilters.length ===
      0
    )) {
    exercisesMsg = formatMessageIntlUtil(
      intl,
      MUSCLE_MESSAGE[muscleUrlParam || musclesFilters[0]]
    ) + ' ' + exercisesMsg
  } else if (equipmentUrlParam ||
    (
      equipmentFilters.length ===
      1 &&
      musclesFilters.length ===
      0 &&
      typesFilters.length ===
      0
    )) {
    exercisesMsg = formatMessageIntlUtil(
      intl,
      EQUIPMENT_MESSAGE[equipmentUrlParam || equipmentFilters[0]]
    ) + ' ' + exercisesMsg
  } else if (typeUrlParam ||
    (
      typesFilters.length ===
      1 &&
      musclesFilters.length ===
      0 &&
      equipmentFilters.length ===
      0
    )) {
    exercisesMsg = formatMessageIntlUtil(
      intl,
      EXERCISE_TYPE_MESSAGE[typeUrlParam || typesFilters[0]]
    ) + ' ' + exercisesMsg
  }

  const title = query
    ? `${exercisesMsg}: ${query}`
    : exercisesMsg

  if (initialLoad && isLoading) {
    return (
      <View
        bgc='white'
        h='100vh'
        centered
      >
        <LoadingIcon
          stroke='black'
          style={{
            width: '30px',
            height: '30px'
          }}
        />
      </View>
    )
  }

  return (
    <Page title={title}>
      <View bgc='white'>
        <InfiniteScroll
          dataLength={exercises.length}
          next={fetchMoreData}
          hasMore
        >
          <View px='16px'>
            <AddExercisesHeader
              isReadOnly={props.isReadOnly}
              isView={props.isView}
            />
            {(
              isQueryLoading ||
              (
                (
                  musclesFilters.length >
                  0 ||
                  equipmentFilters.length >
                  0 ||
                  typesFilters.length >
                  0
                ) && isLoading
              )
            ) && (
              <View
                centered
                py={2}
              >
                <LoadingIcon
                  stroke='black'
                  style={{
                    width: '30px',
                    height: '30px'
                  }}
                />
              </View>
            )}

            {
              exercises.length === 0 &&
              !isQueryLoading &&
              !isLoading && (
                <Text
                  c='#000000'
                  p
                >
                  {formatMessageIntlUtil(intl, messages.noExerciseFound)}
                </Text>
              )
            }

            {
              exercises.map((exerciseId, index) => (
                <ExerciseRow
                  key={index}
                  id={exerciseId}
                  onClick={handleClickExercise}
                />
              ))
            }
          </View>
        </InfiniteScroll>
      </View>
    </Page>
  )
}
